import { render } from "./SkillMatrix.vue?vue&type=template&id=ab1e3d54&scoped=true"
import script from "./SkillMatrix.vue?vue&type=script&lang=js"
export * from "./SkillMatrix.vue?vue&type=script&lang=js"

import "./SkillMatrix.vue?vue&type=style&index=0&id=ab1e3d54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1e3d54"]])

export default __exports__